import { gql } from '@apollo/client';

export const LXP_FILE_QUERY = gql`
    query lxpFile( $lxpFileID: UUID! ) {
        lxpFile(lxpFileID: $lxpFileID) {
            node {
                signedUrl
            }
        }
    }
`;
